import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancelCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.5 24.2 7.8 9.5Q5.6 12.2 5.6 16a10.4 10.4 0 0 0 16.9 8.2m1.6-1.7q2.3-2.7 2.3-6.5A10.4 10.4 0 0 0 9.5 8zM3.2 16a12.8 12.8 0 1 1 25.6 0 12.8 12.8 0 0 1-25.6 0" })
});
export default SvgCancelCircleRegularIcon;
